import type { RouteConfig } from '@acsbe/routing';
import type { RouterContext } from '../../router/context';
import authentication from '../authentication';
import * as index from './_';
import * as layout from './layout';

const appPages: RouteConfig<RouterContext> = {
  ...layout,
  pages: [index, authentication],
};

export default appPages;
